import { SessionService } from './../../Services/session.service';
import { HttpClientService } from "./../../Services/http-client.service";
import { Component, Input, OnDestroy, OnInit, HostListener } from "@angular/core";
import { Subscription } from 'rxjs';
import { AppSettings } from "../../app-settings";
import { JourneyMilestoneService } from "../../Services/journey-milestone.service";
import { HttpHeaders } from '@angular/common/http';
import { CementingStatusService } from '../../Services/cementing-status.service';
import { CEMENTING_LEVEL_DIFFICULTY, CementingCategory, CementingDifficulty, CementingStatus, findCategory } from '../../models/cementing-status';


@Component({
  selector: "app-journey-view",
  templateUrl: "./journey-view.component.html",
  styleUrls: ["./journey-view.component.css"],
})
export class JourneyViewComponent implements OnInit, OnDestroy {
  cementingShortNames = ['CM','CH'];
  loader = AppSettings.loadingCircleImageURL;
  dataLoaded = false;
  /** Set once the Scholaranium cementing status call has answered (null status = no cementing). */
  cementingStatusLoaded = false;
  cementingStatus: CementingStatus | null = null;
  private cementingChanges: Subscription;
  firstLevelStatus;
  allLevelsCompleted: boolean= false;
  screenWidth;
  section: string;
  // state: string = "collapsed";
  iconUrls = {
    New: AppSettings.cdnUrl + "assets/images/not_started_icon.png",
    "Started Early": AppSettings.cdnUrl + "assets/images/inprogress_icon.png",
    "Started Normally":
      AppSettings.cdnUrl + "assets/images/inprogress_icon.png",
    Completed: AppSettings.cdnUrl + "assets/images/completed_white_bg_icon.png",
    Resumed: AppSettings.cdnUrl + "assets/images/resumed_icon.png",
    Abandoned: AppSettings.cdnUrl + "assets/images/abandoned_icon.png",
  };

  @HostListener("window:resize", ["$event"]) onWindowResize() {
    this.screenWidth = window.innerWidth;
    this.validateScreenWidth();
  }

  grade = {
    A: "A",
    B: "B",
    'A-': "A-",
    'B-': "B-",
    C: "C",
    NR: "NR",
    NA: "NA",
  };
  iconClass = {
    // NEW: "not_started_icon",
    'Started Early': "inprogress_icon",
    'Started Normally': "inprogress_icon",
    Resumed: "inprogress_icon",
    Abandoned: "inprogress_icon",
    // COMPLETED: "completed_icon",
  };

  levelStarted = {
    //to change the color of LL text in progress bar
    'Started Early': true,
    'Started Normally': true,
    Completed: true,
    Resumed: true,
    Abandoned: true,
  };

  @Input() journeyCourseId;
  /** Course page name (route :page); the cementing panel builds its in-course quiz / review routes from it. */
  @Input() pageName: string;

  stageBGmap ={
    'LEARNING':'#00AEEF',
    'FOUNDATION':'#FDA40A',
    'CEMENTING':'#22BF95',
    'TEST_READINESS':'#ff6602'
  }

  journeyData:any;
  constructor(
    private journeyMilestoneService: JourneyMilestoneService,
    private httpClientService: HttpClientService,
    private sessionService: SessionService,
    private cementingStatusService: CementingStatusService
  ) {}

  ngOnInit() {
    // A choice recorded in a panel refreshes the whole subject status (both modules).
    this.cementingChanges = this.cementingStatusService.statusChanges$.subscribe(status => {
      if (this.journeyData && status.subject === (this.journeyData['courseShortName'] || '').toUpperCase()) {
        this.cementingStatus = status;
      }
    });
    this.screenWidth = window.innerWidth;
    if (this.journeyCourseId !== -1) {
      this.getData(this.journeyCourseId);
    }
    this.validateScreenWidth();
    this.sessionService.getWebinarComponentState.subscribe((state) => {
      if (state === "expanded") {
        this.collapse_level("collapsed");
      }
    });
    this.sessionService.shareLevelCollapsedStatus("collapsed");
  }
  ngOnDestroy() {
    if (this.cementingChanges) { this.cementingChanges.unsubscribe(); }
  }

  collapse_level(state) {
    if (state == "collapsed") {
      this.journeyData["learningLevels"].forEach((learningLevel) => {
        learningLevel["activityDetailsCollapsed"] = true;
      });
    }
    this.sessionService.shareLevelCollapsedStatus(state);
  }
  getData(journeyCourseID) {
      this.journeyMilestoneService.getData(journeyCourseID).subscribe(data => {
        this.journeyData = data;
        this.dataLoaded = true;
        this.journeyData.learningLevels = (this.journeyData.learningLevels).map(ll=>{
          ll.courseShortName = data['courseShortName'];
          return ll;
        });
        this.sessionService.updateCourseStage(data['courseStage']);
        this.checkAllLevelsCompletedStatus(this.journeyData["learningLevels"]);
        this.firstLevelStatus = this.journeyData["learningLevels"][0]["levelStatus"];
        this.section = this.journeyData['section'];
        this.loadCementingStatus(data['courseShortName']);
      });
  }

  /** Cementing modules of this subject from the Scholaranium status API (one call for Medium and Hard). */
  loadCementingStatus(subject: string) {
    this.cementingStatusLoaded = false;
    this.cementingStatusService.getStatus(subject).subscribe(status => {
      this.cementingStatus = status;
      this.cementingStatusLoaded = true;
    });
  }

  /** Opens the journey level of a cementing module (CM = Medium, CH = Hard) and collapses the other one. */
  openCementingLevel(difficulty: CementingDifficulty) {
    const shortName = difficulty === 'HARD' ? 'CH' : 'CM';
    (this.journeyData && this.journeyData['learningLevels'] || []).forEach(level => {
      if (this.cementingShortNames.includes(level.shortName)) { level.collapsed = level.shortName !== shortName; }
    });
    this.sessionService.shareLevelCollapsedStatus('expanded');
  }

  cementingCategory(shortName: string): CementingCategory | null {
    return findCategory(this.cementingStatus, CEMENTING_LEVEL_DIFFICULTY[shortName]);
  }


  /**
   * @description it will show weather the grades whould be shown or not
   * @param level
   * @returns
   */
  showGrade(level:{shortName:string,levelStatus:string}){
    if(level.shortName === 'CM' || level.shortName==='CH') {
      return level.levelStatus === 'NEW';
    }
    return true;
  }
  checkAllLevelsCompletedStatus(levels) {
    for(let i = 0; i< levels.length; i++) {
      if(!(levels[i]['levelStatus'] || '').toLowerCase().includes('completed')){
        this.allLevelsCompleted = false;
        break;
      }
      this.allLevelsCompleted = true;
    }
  }

  validateScreenWidth() {
    if (this.screenWidth <= 1200) {
      this.grade = {
        A: "A",
        B: "B",
        'A-': "A-",
        'B-': "B-",
        C: "C",
        NR: "NR",
        NA: "NA",
      };
    } else {
      this.grade = {
        A: "A",
        B: "B",
        'A-': "A-",
        'B-': "B-",
        C: "C",
        NR: "NR",
        NA: "NA",
      };
    }
  }
}
